<template>
    <component :is="SkinComponent" v-model="application" :code="code" v-if="initiated" />
</template>

<script>
import api from "@/api";

export default {
    props: {
        skin: { type: String, default: null },
        code: { type: String, default: null },
    },

    data() {
        return {
            application: null,
            initiated: false,
        };
    },
    computed: {
        SkinComponent() {
            return () => import(`./skin/${this.$props.skin}/view.vue`);
        },
        _form() {
            return this.$route.params?._form || this.$attrs._form;
        },
    },

    mounted() {
        this.init();
    },

    methods: {
        async init() {
            this.initiated = false;

            const { application = {} } = await api.v1.apply.applications.get({ _id: this._form, params: { isMine: true } });
            this.application = application;

            this.initiated = true;

            this.$emit("input", this.application);
        },
    },
};
</script>
